
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web-basic",
      function () {
        return require("private-next-pages/web-basic.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web-basic"])
      });
    }
  